import { FiExternalLink } from 'react-icons/fi'
import { Link } from '@reach/router'
import {
  primaryHyperlinkClass,
  secondaryHyperlinkClass
} from '@eggplant/pattern-library'
import type {
  CSSProperties,
  ComponentProps,
  ReactNode
} from 'react'

// Style the Reach Router link to match our own Hyperlink
interface CustomProps {
  variance?: 'primary' | 'secondary'
  isHyperlink?: boolean
  title?: string
  openInNewTab?: false
  isRenderIcon?: boolean
  isInlineLink?: boolean
}

interface OpenNewTabProps {
  children: ReactNode
  openInNewTab: true
  to: string
  isRenderIcon?: boolean
  isInlineLink?: boolean
}

const newTabWrapperFlexStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px'
}

const inlineLinkStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'baseline'
}

type LinkProps = (ComponentProps<typeof Link> & CustomProps) | OpenNewTabProps

const StyledLink = (props: LinkProps) => {
  const {
    openInNewTab,
    children,
    to,
    isRenderIcon,
    isInlineLink = false
  } = props

  if (openInNewTab) {
    const newTabWrapperStyle = isInlineLink
      ? {
        ...newTabWrapperFlexStyle,
        ...inlineLinkStyle
      }
      : newTabWrapperFlexStyle

    return (
      <a
        href={to}
        rel='noopener noreferrer'
        style={newTabWrapperStyle}
        target='_blank'
      >
        {children}
        {isRenderIcon && <FiExternalLink aria-hidden />}
      </a>
    )
  }

  const {
    title,
    isHyperlink,
    variance = 'primary'
  } = props

  const secondaryHyperLinkStyle = variance === 'secondary'
    ? ' ' + secondaryHyperlinkClass
    : ''

  const hyperlinkClassName = primaryHyperlinkClass + secondaryHyperLinkStyle

  return (
    <Link
      className={
        isHyperlink
          ? hyperlinkClassName
          : undefined // link as button is Styled in LinkButton, wrapped Link with LinkButton will inherit the required style
      }
      title={title}
      {...props}
    />
  )
}

export default StyledLink
